import { Button, ButtonGroup } from "@mui/material";
import { Radius } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { SortOrder } from "./utils/buildTimelineItems";

const Timeline = Resources.AnalysisDetail.Goals.Timeline;

const SORT_OPTIONS = [
  { order: "asc", label: Timeline.SortAsc },
  { order: "desc", label: Timeline.SortDesc },
] as const;

type Props = {
  value: SortOrder;
  onChange: (order: SortOrder) => void;
};

export const GoalsSortToggle = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <ButtonGroup variant="outlined" aria-label={t(Timeline.SortOrder)} sx={{ alignSelf: "flex-start" }}>
      {SORT_OPTIONS.map(({ order, label }) => (
        <Button
          key={order}
          variant="outlined"
          onClick={() => onChange(order)}
          sx={(theme) => ({
            height: "40px",
            borderRadius: Radius.M,
            borderColor: theme.colors.borderLight,
            bgcolor: value === order ? theme.colors.backgroundSecondary : "transparent",
            color: value === order ? "text.primary" : "text.secondary",
            boxShadow: "none",
          })}
        >
          {t(label)}
        </Button>
      ))}
    </ButtonGroup>
  );
};
